import React, { useEffect, useState, useCallback, useRef } from "react";
import { apiRequest } from "../utils/api";
import "../styles/SalesCategorySummary.css";

const SalesCategorySummary = ({ storeId }) => {
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const requestControllerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (requestControllerRef.current) {
        requestControllerRef.current.abort();
      }
    };
  }, []);

  const fetchSalesForStore = useCallback(async () => {
    if (!storeId) return;

    if (requestControllerRef.current) {
      requestControllerRef.current.abort();
    }

    const controller = new AbortController();
    requestControllerRef.current = controller;

    setLoading(true);

    try {
      const result = await apiRequest(
        `inventory/store-sales-summary/?store_id=${storeId}`,
        "GET",
        null,
        {},
        true,
        controller.signal
      );

      setSummaryData(result);
      setLoading(false);
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("売上取得エラー:", error);
      setLoading(false);
    }
  }, [storeId]);

  useEffect(() => {
    fetchSalesForStore();
  }, [fetchSalesForStore]);

  if (loading) return <div>売上データを読み込み中...</div>;
  if (!summaryData) return <div>売上データがありません</div>;

  const sortedMergedCategories = summaryData.categories || [];
  const totalTransactions = summaryData.total_transactions || 0;
  const totalSales = summaryData.total_sales || 0;
  const collectedAt = summaryData.collected_at ? new Date(summaryData.collected_at) : null;

  let marineNo = "";

  if (totalSales === 0) {
    marineNo = "marine00";
  } else if (totalSales < 100000) {
    marineNo = "marine01";
  } else if (totalSales < 200000) {
    marineNo = "marine02";
  } else if (totalSales < 300000) {
    marineNo = "marine03";
  } else if (totalSales < 400000) {
    marineNo = "marine04";
  } else if (totalSales < 500000) {
    marineNo = "marine05";
  } else if (totalSales < 600000) {
    marineNo = "marine06";
  } else if (totalSales < 700000) {
    marineNo = "marine07";
  } else if (totalSales < 800000) {
    marineNo = "marine08";
  } else if (totalSales < 900000) {
    marineNo = "marine09";
  } else if (totalSales < 1000000) {
    marineNo = "marine10";
  } else if (totalSales < 1100000) {
    marineNo = "marine10";
  } else if (totalSales < 1200000) {
    marineNo = "marine10";
  } else if (totalSales < 1300000) {
    marineNo = "marine10";
  } else if (totalSales < 1400000) {
    marineNo = "marine10";
  } else if (totalSales < 1500000) {
    marineNo = "marine10";
  } else if (totalSales < 1600000) {
    marineNo = "marine10";
  } else if (totalSales > 999999) {
    marineNo = "marine11";
  }

  return (
    <div className="salesCategorySummaryContainer">
      <div className="salesimagebox">
        <img src={`/media/system_images/${marineNo}.png`} alt={`船長`} />
      </div>

      <div className="salesLeft">
        <div className="salesTitlePlus">
          <label onClick={fetchSalesForStore} className="reloadButton">🔄</label> 本日の売上
        </div>

        <div className="salesTitle">
          ({collectedAt &&
            `${collectedAt.toLocaleDateString('ja-JP')} ${collectedAt.toLocaleTimeString('ja-JP', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })} 時点`
          })
        </div>

        <div className="salesAmount">¥{totalSales.toLocaleString()}</div>
        <div className="salesCount">({totalTransactions}点)</div>
      </div>

      <div className="salesRight">
        {sortedMergedCategories.map((cat) => (
          <div className="categoryItem" key={cat.category_id ?? "null"}>
            {cat.category_name || "未設定"}：¥{Number(cat.total_sales || 0).toLocaleString()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesCategorySummary;